import { setProjectInterceptors } from "@/api/httpsClient";
import { setAxiosInstance, setupWebManageInterceptors } from "@/utils/apiInterceptor";
import { getApiClient } from "@api";


// 인터셉터 초기화 함수
const initializeInterceptors = function () {
  try {
    // API 클라이언트 가져오기
    const apiClient = getApiClient();
    // axios 인스턴스 설정
    const axiosInstance = apiClient.getAxiosInstance();
    setAxiosInstance(axiosInstance);
    // 인터셉터 설정
    setProjectInterceptors(() => setupWebManageInterceptors());
  } catch (error) {
    console.error("인터셉터 초기화 실패:", error);
  }
};

export const initializeApiClient = () => {
  initializeInterceptors();
};
